import { render, staticRenderFns } from "./OrderItems.vue?vue&type=template&id=1cd03231&"
import script from "./OrderItems.vue?vue&type=script&lang=js&"
export * from "./OrderItems.vue?vue&type=script&lang=js&"
import style0 from "./OrderItems.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QList,QItem,QItemSection,QItemLabel,QCardActions,QBtn,QAvatar,QTable,QInnerLoading,QSpinner,QSelect,QTr,QTh,QBtnDropdown,QTd,QChip,QTooltip,QSpace,QSeparator,QForm,QCheckbox,QInput,QField,Ripple,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QList,QItem,QItemSection,QItemLabel,QCardActions,QBtn,QAvatar,QTable,QInnerLoading,QSpinner,QSelect,QTr,QTh,QBtnDropdown,QTd,QChip,QTooltip,QSpace,QSeparator,QForm,QCheckbox,QInput,QField})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {Ripple,ClosePopup})
